import * as React from 'react';

export function IconNumberedList(
  props: React.ComponentProps<'svg'>,
): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 6H21M10 12H21M10 18H21M3 4H4V9M3 9H5M3 15C3 14 4 13.5 5 14C6 14.5 6 15.5 5 16.5L3 19H6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
